import { DOCUMENT } from '@angular/common';
import { Component, Inject, Renderer2 } from '@angular/core';
import { IonApp, IonRouterOutlet, Platform } from '@ionic/angular/standalone';
import { Keyboard } from '@capacitor/keyboard';
import { Capacitor } from '@capacitor/core';
import { TranslateService } from '@ngx-translate/core';
import { RTLLanguagesCodes } from './helpers/constant/supported-language';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  standalone: true,
  imports: [
    IonApp,
    IonRouterOutlet
  ],
  providers: []
})
export class AppComponent {
  constructor(
    private platform: Platform,
    @Inject(DOCUMENT) private document: Document,
    private renderer: Renderer2,
    public translate: TranslateService,
  ) {

    this.translate.onLangChange.subscribe((value) => {
      this.document.querySelector("html")?.setAttribute("lang", value.lang.replace("-", "_"));
      if (RTLLanguagesCodes.includes(value.lang.toLowerCase())) {
        this.document.querySelector("html")?.setAttribute("dir", 'rtl');
      } else {
        this.document.querySelector("html")?.setAttribute("dir", 'ltr');
      }
    });

    // this.keyboardListener();
    this.initializeApp();
  }
  initializeApp() {
    this.platform.ready().then(() => {
      this.handleKeyboardEvents();
      this.addCustomScrollbarStyle();
    });
  }

  handleKeyboardEvents() {
    const platform = Capacitor.getPlatform();
    if (platform === 'ios' || platform === 'android') {
      // Only add keyboard event listeners for iOS/Android
      Keyboard.addListener('keyboardWillShow', () => {
        const content = document.querySelector('ion-content');
        if (content) {
          content.style.setProperty('--keyboard-offset', '290px');
        }
      });

      Keyboard.addListener('keyboardWillHide', () => {
        const content = document.querySelector('ion-content');
        if (content) {
          content.style.setProperty('--keyboard-offset', '0px');
        }
      });
    } else {
      this.document.querySelector('html')?.classList.add('keyboard-closed');
    }
  }

  keyboardListener() {
    window.addEventListener('keyboardDidShow', (event: any) => {
      this.document.querySelector('html')?.classList.add('keyboard-open');
    })
    window.addEventListener('keyboardDidHide', () => {
      this.document.querySelector('html')?.classList.remove('keyboard-open');
    })
  }

  addCustomScrollbarStyle() {
    console.log('style')
    const style = this.renderer.createElement('style');
    style.type = 'text/css';
    style.innerHTML = `
      ::-webkit-scrollbar {
        width: 3px;
        background: transparent;
      }

      ::-webkit-scrollbar-track {
        border-radius: 15px;
      }

      ::-webkit-scrollbar-thumb {
        border-radius: 15px;
      }
      ::part(scroll) {
        scrollbar-width: thin;
      }
    `; 
    this.renderer.appendChild(document.head, style);
  }
}